import * as yup from 'yup';
export const billingLogSchema = yup
    .object()
    .camelCase()
    .shape({
    id: yup.string().required().ensure(),
    code: yup.string().required().ensure(),
    codeName: yup.string().required().ensure(),
    codeDescription: yup.string().required().ensure(),
    codeDate: yup.date().nullable(),
    reviewType: yup.string().nullable(),
    pending: yup.boolean(),
    billedAt: yup.date().nullable(),
    patientId: yup.string().required().ensure(),
    firstname: yup.string().required().ensure(),
    lastname: yup.string().required().ensure(),
    dob: yup.date().required(),
    patientReportId: yup.string().nullable().ensure(),
});
